export const setTypeOfAlgo = (payload) => {
    return {
        type: "SET_TYPE_OF_ALGO",
        payload: payload
    }
}